import React, { Component } from "react"
import axios from "axios"
import moment from "moment"
import { Button, FormControl, Modal, Spinner } from "react-bootstrap"
import AxiosConfig from "../../../../../../utilities/AxiosConfig"
import snackBar from "../../../../../../utilities/snackBar/SnackBar"
import EditIncidentTypes from "../../../../Types/EditIncidentTypes"
import "../Incident.css"

interface Props {
    toggleDelete: Function
    incident: EditIncidentTypes
    userId: string
    refreshIncidents: Function
    setOpenIncident: Function
}

interface State {
    loading: boolean
    confirm: boolean
    input: string
}

class DeleteIncident extends Component<Props, State> {

    state = {
        loading: false,
        confirm: false,
        input: "",
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        this.manageState([{ key: "input", value: input }])
    }

    manageState = (arr: Array<{ key: string, value?: string }>) => {
        let temp: any = this.state
        for (let i = 0; i < arr.length; i++) {
            if (!arr[i].value) {
                temp[arr[i].key] = !temp[arr[i].key]
            } else {
                temp[arr[i].key] = arr[i].value
            }
        }
        this.setState(temp)
    }

    match = () => {
        let a = this.props.incident.WorkersCompensationIncidentId.toString().trim()
        let b = this.state.input
        if (a === b) {
            return true
        }
        return false
    }

    handleDelete = () => {
        this.manageState([{ key: "loading" }])
        let rb = this.props.incident
        rb.DeletedDateUTC = moment().format()
        rb.DeletedBy = this.props.userId
        this.setState({ loading: true, })
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/UpdateWorkCompIncidentPost", rb, AxiosConfig.configValue("min"))
            .then(() => {
                this.manageState([{ key: "loading" }])
                this.props.toggleDelete()
                this.props.refreshIncidents()
                this.props.setOpenIncident(-1)
                snackBar({ text: "Incident Deleted", type: "secondary", timeout: 4000 })
            })
            .catch(err => {
                //console.log(err)
                this.manageState([{ key: "loading" }])
                snackBar({ text: "Failed to delete incident", type: "error", timeout: 4000 })
            })
    }

    render() {

        const incident = this.props.incident
        let match = false
        if (incident.WorkersCompensationIncidentId) {
            match = this.match()
        }

        return (
            <div className="DeleteIncident">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="DeleteIncidentDiscardNagHeader">
                            {!incident.WorkersCompensationIncidentId && <span id="delete-incident-backdrop" className="material-icons">delete</span>}
                            {!incident.WorkersCompensationIncidentId && <Spinner id="delete-incident-discard-nag-spinner" animation="border" />}
                            {incident.WorkersCompensationIncidentId && <p>Type <span>{incident.WorkersCompensationIncidentId}</span> below to confirm</p>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="DeleteIncidentDiscardNagBody">
                            <FormControl
                                placeholder={"..."}
                                onChange={this.handleChange}
                                value={this.state.input || ""}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DeleteIncidentDiscardNagFooter">
                            {!this.state.loading && <Button id="delete-incident-discard-nag-back-btn" variant="secondary" onClick={() => this.props.toggleDelete()}>Back</Button>}
                            {!this.state.loading && <Button id="delete-incident-discard-nag-discard-btn" variant="danger" disabled={!match} onClick={() => this.handleDelete()}>Delete</Button>}
                            {this.state.loading && <Spinner id="delete-incident-discard-nag-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DeleteIncident